type ThreadRequestGuard = {
  requestID: number;
  latestRequestID: number;
  threadIdentity: string;
  latestThreadIdentity: string;
  conversationKey: string;
  selectedConversationKey?: string;
};

type ThreadMessageParticipant<TParticipant> = {
  sender: TParticipant;
  receiver: TParticipant;
};

// 页面级消息只能由当前会话的最新请求回填，避免旧会话异步响应覆盖新会话。
export const isConferenceChatThreadRequestCurrent = ({
  requestID,
  latestRequestID,
  threadIdentity,
  latestThreadIdentity,
  conversationKey,
  selectedConversationKey,
}: ThreadRequestGuard) =>
  latestRequestID === requestID &&
  latestThreadIdentity === threadIdentity &&
  selectedConversationKey === conversationKey;

// 静默轮询只允许合并当前用户与当前对端之间的消息，清除任何遗留线程数据。
export const filterConferenceChatThreadMessages = <
  TParticipant,
  TMessage extends ThreadMessageParticipant<TParticipant>,
>(
  messages: TMessage[],
  currentParticipant: TParticipant,
  peerParticipant: TParticipant,
  sameParticipant: (left: TParticipant, right: TParticipant) => boolean
) =>
  messages.filter(
    (message) =>
      (sameParticipant(message.sender, currentParticipant) &&
        sameParticipant(message.receiver, peerParticipant)) ||
      (sameParticipant(message.receiver, currentParticipant) &&
        sameParticipant(message.sender, peerParticipant))
  );
